"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialToitEnPenteThermalPerformanceState = exports.TOIT_EN_PENTE_MINIMUM_INSULATION_THICKNESS = exports.TOIT_EN_PENTE_R_VALUE_RSE = exports.TOIT_EN_PENTE_R_VALUE_RSI = void 0;
exports.TOIT_EN_PENTE_R_VALUE_RSI = 0.10;
exports.TOIT_EN_PENTE_R_VALUE_RSE = 0.04;
exports.TOIT_EN_PENTE_MINIMUM_INSULATION_THICKNESS = 90;
exports.initialToitEnPenteThermalPerformanceState = {
    UCValue: null,
    RTValue: null,
    toitInsulation: {
        thickness: null,
        lambda: null,
        RValue: null,
    },
};
